import React from 'react';
import BroadcastIndex from './broadcasts';

export default function () {
  return <BroadcastIndex version="replay" />;
}
